import * as R from 'ramda';
import { MIN_DIGITS_CELL_PHONE_VALIDATION } from '../constants';

export const checkIsMobileLengthValidate = R.compose(
  R.gt(R.__, MIN_DIGITS_CELL_PHONE_VALIDATION),
  R.length,
  R.replace(/\D/g, ''),
  R.defaultTo(''),
);
